import React, { useEffect, useState } from "react";
import Blank from "../../DefaultStyles/Blank";
import GatheringSection from "./PartyBoard/GatheringSection";
import PartyCreateSection from "./PartyBoard/CreateSection";
import ServiceSection from "./PartyBoard/ServiceSection";
import StatusSection from "./PartyBoard/StatusSection";
import DashBoardDateFilter from "./DashBoardDateFilter";
import dayjs from "dayjs";
import { DashBoardDateFilterContainer, DashBoardSection } from "./UserBoard";
import PayHistorySection from "./PayBoard/PayHistorySection";
import PartyHistorySection from "./PartyBoard/PartyHistorySection";
import PartyHistorySection_make from "./PartyBoard/PartyHistorySection_make";

export default function PartyBoard() {
  const [filter, setFilter] = useState({
    startDate: dayjs().add(-7, "day")?.format("YYYY-MM-DD") ?? "",
    endDate: dayjs().add(-1, "day")?.format("YYYY-MM-DD") ?? "",
    isAccum: false,
  });

  const [serviceFilter, setServiceFilter] = useState({
    startDate: "",
    endDate: "",
    isAccum: false,
  });

  const [statusFilter, setStatusFilter] = useState({
    startDate: "",
    endDate: "",
    isAccum: false,
  });

  const [gatheringFilter, setGatheringFilter] = useState({
    startDate: "",
    endDate: "",
    isAccum: false,
  });

  useEffect(() => {
    if (filter.endDate !== "") {
      setServiceFilter({
        ...serviceFilter,
        startDate: filter.startDate,
        endDate: filter.endDate,
      });

      setStatusFilter({
        ...statusFilter,
        startDate: filter.startDate,
        endDate: filter.endDate,
      });

      setGatheringFilter({
        ...gatheringFilter,
        startDate: filter.startDate,
        endDate: filter.endDate,
      });
    }
  }, [filter]);

  return (
    <DashBoardSection>
      <DashBoardDateFilterContainer>
        <DashBoardDateFilter
          setFilter={setFilter}
          filter={filter}
          isAfter={{
            value: 31,
            unit: "day",
          }}
        />
      </DashBoardDateFilterContainer>

      {/* 신규 파티 생성 현황 */}
      {/* <PartyCreateSection filter={filter} setFilter={setFilter} /> */}
      <PartyHistorySection_make filter={filter} setFilter={setFilter} />
      <Blank blankHeight={40} />

      <PartyHistorySection filter={filter} setFilter={setFilter} />

      {/* 서비스별 생성 파티 현황 */}
      <ServiceSection filter={serviceFilter} setFilter={setServiceFilter} />
      <Blank blankHeight={40} />

      {/* 파티 상태 현황 */}
      <StatusSection filter={statusFilter} setFilter={setStatusFilter} />
      <Blank blankHeight={40} />

      {/* 파티 모집 현황 */}
      <GatheringSection
        filter={gatheringFilter}
        setFilter={setGatheringFilter}
      />
      <Blank blankHeight={40} />
    </DashBoardSection>
  );
}
